import {createApp} from "vue"
import Cleave from "vue-cleave-component"
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption
} from "@headlessui/vue"
import i18n from "./i18n"
import PortalVue from "portal-vue"
import DateInput from "./components/Date"
import PhoneInput from "./components/Phone"
import ImageUpload from "./components/ImageUpload";
import Toggle from "./components/Toggle";
import Tooltip from "./components/Tooltip";
import ProfileSettingsNotificationsForm from "./components/profile/settings/NotificationsForm";
import RegisterPhoneOrEmailForm from "./components/register/PhoneOrEmailForm";
import OrderChooseValidityForm from "./components/order/ChooseValidityForm";
import DatatransForm from "./components/DatatransForm";
import DataLoader from "./components/DataLoader";
import CheckForTransactions from "./components/CheckForTransactions";
import VueCountdown from "@chenfengyuan/vue-countdown";

const app = createApp({
    components: {
        Cleave,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        RadioGroup,
        RadioGroupLabel,
        RadioGroupOption,
        DateInput,
        PhoneInput,
        ImageUpload,
        Toggle,
        Tooltip,
        DatatransForm,
        DataLoader,
        CheckForTransactions,
        VueCountdown,
        ProfileSettingsNotificationsForm,
        RegisterPhoneOrEmailForm,
        OrderChooseValidityForm
    },
    data() {
        return {
            navigationOpen: false,
            test: '',
        }
    },
    methods: {
        redirect(url)
        {
            window.location.replace(url);
        }
    }
});
app.use(i18n)
app.use(PortalVue)

export default app
